export const Race = () => {
	return (
		<>
			<h1>Race</h1>
		</>
	);
}